import React, { useState } from "react";
import {
  Box,
  Typography,
  IconButton,
  MenuItem,
  Select,
  Tooltip,
} from "@mui/material";
import SettingsIcon from "@mui/icons-material/Settings";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";

import InventoryIcon from "@mui/icons-material/Inventory";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import AssignmentIcon from "@mui/icons-material/Assignment";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";

import { useNavigate } from "react-router-dom";

// const ENV = process.env.REACT_APP_ENVT;
// const isProd = ENV === "PROD";
const alertDomains = [
  {
    label: "Inventory",
    icon: <InventoryIcon sx={{ color: "#1A535C" }} />,
    route: "/alerts/inventory",
  },
  {
    label: "Inbound Shipments",
    icon: <LocalShippingIcon sx={{ color: "#1A535C" }} />,
    route: "/alerts/inbound-shipments",
  },
  {
    label: "Outbound Shipments",
    icon: <LocalShippingIcon sx={{ color: "#1A535C" }} />,
    route: "/alerts/outbound-shipments",
  },
  {
    label: "Purchase Orders",
    icon: <AssignmentIcon sx={{ color: "#1A535C" }} />,
    route: "/alerts/purchase-orders",
  },
  {
    label: "Sales Orders",
    icon: <ShoppingCartIcon sx={{ color: "#1A535C" }} />,
    route: "/alerts/sales-orders",
  },
];

const timeOptions = [
  "All",
  "Last hour",
  "Last 12 hours",
  "Last 24 hours",
  "Last 7 days",
];

const Alerts = ({ open, onClose }) => {
  const [selectedTime, setSelectedTime] = useState("All");
  const navigate = useNavigate();

  if (!open) return null;

  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        right: 0,
        width: 380,
        height: "100vh",
        bgcolor: "#fff",
        boxShadow: "-2px 0 6px rgba(0,0,0,0.15)",
        zIndex: 1300,
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* HEADER */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          px: 2,
          py: 1.5,
          borderBottom: "1px solid #eee",
        }}
      >
        <IconButton onClick={onClose}>
          <ArrowBackIosNewIcon fontSize="small" />
        </IconButton>

        <Typography variant="h6" sx={{ flexGrow: 1, ml: 1, fontWeight: 600 }}>
          Alerts
        </Typography>

        {/* <Select
          size="small"
          value={selectedTime}
          onChange={(e) => setSelectedTime(e.target.value)}
          sx={{ fontSize: "0.75rem", mr: 1 }}
        >
          {timeOptions.map((opt) => (
            <MenuItem key={opt} value={opt}>
              {opt}
            </MenuItem>
          ))}
        </Select> */}

        <Tooltip title="Preferences" arrow>
          <IconButton
            size="small"
            onClick={() => {
              if (onClose) onClose();
              navigate("/core/preferences/alert-preferences");
            }}
          >
            <SettingsIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Box>

      {/* DOMAIN ROWS */}
      <Box sx={{ p: 1 }}>
        {alertDomains.map((dom) => (
          <Box
            key={dom.label}
            onClick={() => {
               if (onClose) onClose();
              navigate(dom.route);
            }}
            sx={{
              display: "flex",
              alignItems: "center",
              p: 1.5,
              borderRadius: 2,
              mb: 1,
              cursor: "pointer",
              backgroundColor: "#F7F9FA",
              transition: "0.2s",
              "&:hover": {
                backgroundColor: "#E3F2F4",
              },
            }}
          >
            {/* ICON */}
            <Box sx={{ mr: 2 }}>{dom.icon}</Box>

            {/* LABEL */}
            <Typography sx={{ flexGrow: 1, fontWeight: 600, color: "#1A535C", display: "flex",
              alignItems: "center" }}>
              {dom.label}
            </Typography>

            {/* ALERT COUNT – you will update with API later */}
            {/* <Box
              sx={{
                background: "#1A535C",
                color: "white",
                px: 1.2,
                py: 0.2,
                borderRadius: 1,
                fontSize: "0.75rem",
                fontWeight: 600,
              }}
            >
              0
            </Box> */}
          </Box>
       
       ))}
      </Box>
    </Box>
  );
};

export default Alerts;